import { getTickets } from 'controller/wallet/getTickets'

export const WalletController = {
  getTickets,
}
